// ============================================================================
// view.projects — the Projects page (owner decisions D1-D17, 2026-10-20)
// ============================================================================
// One authenticated RPC read, `projects.jobs` (list_project_jobs): every live
// job with its people and photos, plus the people who may be assigned. Writes
// go through MUTATION.PROJECT_JOB_OPERATION (project_job_operation), which
// declares this read as one it invalidates; the tables stay private, so the
// mutation guard proves them from the committed 256 SQL. The job drawer is
// selected by the ?job= search value, not by a pathname branch, so this is one
// surface with one read.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'view.projects',
  obligations: Object.freeze([Object.freeze({id: 'projects.jobs', owner: 'permanent'})]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
